import { useTranslation } from 'react-i18next';

import { Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { useGetTotalUsersQuery } from '@app/store/slices/users/usersApi';
import { DOMLogo, loadAvatar } from '@app/assets';

export function DefaultLoadingContent() {
  const { data: usersTotal } = useGetTotalUsersQuery();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 pl-[30px]">
      <img src={DOMLogo} alt="DOM" className="w-[233px]" />
      <Heading level={4} className="font-bold text-secondary-foreground">
        {t('loader.remember')}
      </Heading>
      <div className="mt-1.5 flex items-center gap-1.5">
        <img src={loadAvatar} alt="people" className="h-5" />
        <Paragraph className="text-[13px] font-semibold leading-none text-secondary-foreground">
          {usersTotal?.total || '. . .'} <span className="font-bold">{t('loader.people')}</span>
        </Paragraph>
      </div>
      <Paragraph className="mt-1 text-[13px] pl-[49px] font-semibold leading-none text-secondary-foreground">
        {usersTotal?.totalGiftedItems || '. . .'}{' '}
        <span className="font-bold">{t('loader.gifts')}</span>
      </Paragraph>
    </div>
  );
}
